

import React, { useEffect } from "react";
import { Modal } from "antd";
import { useSelector } from "react-redux";  

const PopupUI = ({ popupContent, isAdd, isUpdate, handleClose, title , isOpen ,width}) => {
  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;
  console.log(isdarkMode)
  return (
    <Modal
      // title={<p className="font-bold ">{title}</p>} 
      open={isAdd || isUpdate }
      onCancel={handleClose}
      footer={null}
      width={width||800}
      className={`custom-modal  ${isdarkMode ? " group-custom-modal-dark  group-custom-modal-header group-labels group-input group-select-input-background " : "whitemode"} `}
    >
      <div
          className={` text-lg font-bold text-start py-3 ${
            isdarkMode ? " text-white" : "text-white"
          }  -mt-6 rounded-t-lg mb-0  px-3 bg-blue-900`}
          // style={{ backgroundColor:  color.themeConfig.colorPrimaryHover}}
        >
          {title}
        </div>
      <div className="form-input-details space-y-2 px-2 flex justify-center border p-3">
        {popupContent}
      </div>
    </Modal>
  );
};

export default PopupUI;










